/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0CalendarEventTypeCompanyIdCalendarPost$Json } from '../fn/calendar/api-v-0-calendar-event-type-company-id-calendar-post-json';
import { ApiV0CalendarEventTypeCompanyIdCalendarPost$Json$Params } from '../fn/calendar/api-v-0-calendar-event-type-company-id-calendar-post-json';
import { apiV0CalendarEventTypeCompanyIdCalendarPost$Plain } from '../fn/calendar/api-v-0-calendar-event-type-company-id-calendar-post-plain';
import { ApiV0CalendarEventTypeCompanyIdCalendarPost$Plain$Params } from '../fn/calendar/api-v-0-calendar-event-type-company-id-calendar-post-plain';
import { apiV0CalendarEventTypeCompanyIdCalendarsGet$Json } from '../fn/calendar/api-v-0-calendar-event-type-company-id-calendars-get-json';
import { ApiV0CalendarEventTypeCompanyIdCalendarsGet$Json$Params } from '../fn/calendar/api-v-0-calendar-event-type-company-id-calendars-get-json';
import { apiV0CalendarEventTypeCompanyIdCalendarsGet$Plain } from '../fn/calendar/api-v-0-calendar-event-type-company-id-calendars-get-plain';
import { ApiV0CalendarEventTypeCompanyIdCalendarsGet$Plain$Params } from '../fn/calendar/api-v-0-calendar-event-type-company-id-calendars-get-plain';
import { Calendar } from '../models/calendar';

@Injectable({ providedIn: 'root' })
export class CalendarService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0CalendarEventTypeCompanyIdCalendarsGet()` */
  static readonly ApiV0CalendarEventTypeCompanyIdCalendarsGetPath = '/api/v0/calendarEventType/{companyId}/calendars';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0CalendarEventTypeCompanyIdCalendarsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CalendarEventTypeCompanyIdCalendarsGet$Plain$Response(params: ApiV0CalendarEventTypeCompanyIdCalendarsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Calendar>>> {
    const obs = apiV0CalendarEventTypeCompanyIdCalendarsGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0CalendarEventTypeCompanyIdCalendarsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CalendarEventTypeCompanyIdCalendarsGet$Plain(params: ApiV0CalendarEventTypeCompanyIdCalendarsGet$Plain$Params, context?: HttpContext): Observable<Array<Calendar>> {
    const resp = this.apiV0CalendarEventTypeCompanyIdCalendarsGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Calendar>>): Array<Calendar> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0CalendarEventTypeCompanyIdCalendarsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CalendarEventTypeCompanyIdCalendarsGet$Json$Response(params: ApiV0CalendarEventTypeCompanyIdCalendarsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Calendar>>> {
    const obs = apiV0CalendarEventTypeCompanyIdCalendarsGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0CalendarEventTypeCompanyIdCalendarsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CalendarEventTypeCompanyIdCalendarsGet$Json(params: ApiV0CalendarEventTypeCompanyIdCalendarsGet$Json$Params, context?: HttpContext): Observable<Array<Calendar>> {
    const resp = this.apiV0CalendarEventTypeCompanyIdCalendarsGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Calendar>>): Array<Calendar> => r.body)
    );
  }

  /** Path part for operation `apiV0CalendarEventTypeCompanyIdCalendarPost()` */
  static readonly ApiV0CalendarEventTypeCompanyIdCalendarPostPath = '/api/v0/calendarEventType/{companyId}/calendar';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0CalendarEventTypeCompanyIdCalendarPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0CalendarEventTypeCompanyIdCalendarPost$Plain$Response(params: ApiV0CalendarEventTypeCompanyIdCalendarPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Calendar>> {
    const obs = apiV0CalendarEventTypeCompanyIdCalendarPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0CalendarEventTypeCompanyIdCalendarPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0CalendarEventTypeCompanyIdCalendarPost$Plain(params: ApiV0CalendarEventTypeCompanyIdCalendarPost$Plain$Params, context?: HttpContext): Observable<Calendar> {
    const resp = this.apiV0CalendarEventTypeCompanyIdCalendarPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Calendar>): Calendar => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0CalendarEventTypeCompanyIdCalendarPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0CalendarEventTypeCompanyIdCalendarPost$Json$Response(params: ApiV0CalendarEventTypeCompanyIdCalendarPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Calendar>> {
    const obs = apiV0CalendarEventTypeCompanyIdCalendarPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0CalendarEventTypeCompanyIdCalendarPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0CalendarEventTypeCompanyIdCalendarPost$Json(params: ApiV0CalendarEventTypeCompanyIdCalendarPost$Json$Params, context?: HttpContext): Observable<Calendar> {
    const resp = this.apiV0CalendarEventTypeCompanyIdCalendarPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Calendar>): Calendar => r.body)
    );
  }

}
